// Keep the configured rows intact before applying country-dependent visibility.
export function visibleFieldLayout(fields, isVisible) {
  const rows = [];
  let pending = null;
  for (const field of fields) {
    const half = field.width === "half"
      && !["product_information", "discount_code"].includes(field.name);
    if (half && pending) {
      pending.push(field);
      pending = null;
    } else {
      const row = [field];
      rows.push(row);
      pending = half ? row : null;
    }
  }
  return rows.flatMap((row) => {
    const visible = row.filter(isVisible);
    return visible.map((field) => ({ ...field, width: visible.length === 2 ? "half" : "full" }));
  });
}
